var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3040_12762)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5 24C48.5 37.2548 37.7548 48 24.5 48C11.2452 48 0.5 37.2548 0.5 24C0.5 10.7452 11.2452 0 24.5 0C37.7548 0 48.5 10.7452 48.5 24ZM25.3601 17.7179C23.0257 18.6888 18.3603 20.6984 11.3638 23.7466C10.2277 24.1984 9.63251 24.6404 9.57834 25.0726C9.48677 25.803 10.4014 26.0906 11.6469 26.4822C11.8164 26.5355 11.9919 26.5907 12.1719 26.6492C13.3973 27.0475 15.0457 27.5135 15.9026 27.5321C16.6799 27.5489 17.5475 27.2284 18.5053 26.5707C25.0423 22.158 28.4168 19.9276 28.6286 19.8795C28.7781 19.8456 28.9852 19.803 29.1255 19.9277C29.2659 20.0524 29.2521 20.2886 29.2372 20.352C29.1466 20.7383 25.5562 24.0762 23.6982 25.8036C23.119 26.3421 22.7081 26.724 22.6242 26.8113C22.436 27.0067 22.2443 27.1915 22.06 27.3692C20.9215 28.4667 20.0678 29.2896 22.1072 30.6336C23.0873 31.2794 23.8715 31.8135 24.6539 32.3463C25.5084 32.9282 26.3606 33.5085 27.4632 34.2313C27.7442 34.4155 28.0125 34.6068 28.2738 34.7931C29.2681 35.5019 30.1615 36.1388 31.2652 36.0373C31.9065 35.9782 32.5689 35.3752 32.9053 33.5767C33.7004 29.3263 35.2633 20.1169 35.6244 16.3219C35.6561 15.9895 35.6163 15.5639 35.5843 15.3771C35.5523 15.1904 35.4855 14.9242 35.2427 14.7272C34.9552 14.4939 34.5113 14.4447 34.3127 14.4482C33.41 14.4641 32.0251 14.9456 25.3601 17.7179Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3040_12762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramNegative);
export default __webpack_public_path__ + "static/media/Telegram - Negative.6c2049c1c13fea9217c56c5354f0247b.svg";
export { ForwardRef as ReactComponent };